import { render, staticRenderFns } from "./BenchmarkChart.vue?vue&type=template&id=6fa73fcc&scoped=true&"
import script from "./BenchmarkChart.vue?vue&type=script&lang=js&"
export * from "./BenchmarkChart.vue?vue&type=script&lang=js&"
import style0 from "./BenchmarkChart.vue?vue&type=style&index=0&id=6fa73fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa73fcc",
  null
  
)

export default component.exports